import React, {useState} from 'react'

interface Props {video: string, width?: string, height?: string, styles?: {}}

const vimeoBase = `https://player.vimeo.com/video`;

function VimeoPlayer(props: Props) {
    const { video, width, height } = props

    return (
      <iframe
        src={ video }
        style={{ ...props.styles, width: props.width ? width : '100%', height: props.height ? props.height : "100%" }}
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen={true}
       
      />
    );
}

export default VimeoPlayer;



// WEBPACK FOOTER //
// ./src/components/VimeoPlayer/VimeoPlayer.Component.tsx